import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import * as N from "./userNftDetailElement";
import * as C from "components/common";

import nftdetail from "assets/boy-robot.png";
import logo from "assets/logo.svg";
import { CommonUtility, ContractUtility } from "utility";
import { useAppSelector } from "store/store";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { ChangeFavouriteHook } from "hooks";
import { useParams } from "react-router-dom";

import polygonIcon from "assets/polygonIcon.png";
import ethIcon from "assets/ethIcon.png";

const NetworkImageComp = (id) => {
  const [networkImg, setNetworkImg] = useState("");

  useEffect(() => {
    if (Number(id?.id) === 137) {
      setNetworkImg(polygonIcon);
    } else {
      setNetworkImg(ethIcon);
    }
  }, [id]);

  return <img src={networkImg} width={20} />;
};

type Props = {
  nftDetailsCard?: boolean;
  nftDetailsCardCollapse?: boolean;
  nftPropertiesCard?: boolean;
  data: any;
};
const NftDetailsSidebar: React.FC<Props> = ({ data }) => {
  const attributes = data?.attributes ? JSON.parse(data.attributes) : [];
  const params = useParams();

  const { nftFavourite } = useAppSelector((state) => state.favouritesData);

  const { changeFav, removeData, addData } = ChangeFavouriteHook();

  let contractDetails = [
    {
      key: "Contract Address",
      value: data?.asset_contract.address,
    },
    {
      key: "Token Id",
      value: data?.token_id,
    },
    {
      key: "Token Standard",
      value: data && data?.asset_contract.schema_name,
    },
  ];

  const { web3 } = useAppSelector((state) => state.web3Connect);

  const [searchParams, setSearchParams] = useSearchParams();
  const nftNetwork = searchParams.get("chain");

 
  useEffect(() => {
    (addData || removeData) && data?.refetchFav()
   }, [addData, removeData]);

  return (
    <div>
      <C.MainCard nftDetailsCard>
        <C.CardHeader className="bg-white text-black  ">
          <div className=" d-flex align-items-center justify-content-between">
            <div>Alient</div>
            <div>
              <span>
                {nftFavourite.userFavourite ? (
                  <AiFillHeart
                    onClick={() =>
                      web3 ? changeFav({ nft_id: params?.id }) : null
                    }
                    style={{
                      marginRight: "5px",
                      marginBottom: "3px",
                      cursor: web3 ? "pointer" : "not-allowed",
                    }}
                  />
                ) : (
                  <AiOutlineHeart
                    onClick={() =>
                      web3 ? changeFav({ nft_id: params?.id }) : null
                    }
                    style={{
                      marginRight: "5px",
                      marginBottom: "3px",
                      cursor: web3 ? "pointer" : "not-allowed",
                    }}
                  />
                )}
                {nftFavourite?.favourites?.length}
              </span>
            </div>
          </div>
        </C.CardHeader>
        <C.CardImg src={data?.image_preview_url || data?.image || nftdetail} />
      </C.MainCard>
      <C.MainRow>
        <C.MainCol>
          <C.MainCard nftDetailsCardCollapse>
            <C.CardHeader>Description</C.CardHeader>

            <N.NftDescTitle>
              Created by{" "}
              <span>
                {" "}
                <a
                // href={`https://etherscan.io/address/0x00...000000`}
                // target="_blank"
                >
                  0x00...000000
                </a>
              </span>
              <N.NftToolTip title="verified">
                {/* <img src={logo} width={20} alt="" /> */}
              </N.NftToolTip>{" "}
            </N.NftDescTitle>
            <N.NftDetailDesc>{data && data?.description}</N.NftDetailDesc>
            <C.NftCollapse>
              <C.CollapsePanel
                header={
                  <N.CollapseHeader>
                    <N.CollapseHeaderTitle>Properties</N.CollapseHeaderTitle>
                  </N.CollapseHeader>
                }
                key="1"
              >
                <C.MainRow>
                  {data &&
                    attributes?.map((item) => (
                      <C.MainCol lg={4} xs={6} sm={6} md={4}>
                        <C.MainCard nftPropertiesCard>
                          <N.NftPropertiesTitle>
                            {item?.trait_type}
                          </N.NftPropertiesTitle>
                          <N.NftPropertiesDesc>
                            {item?.value}
                          </N.NftPropertiesDesc>
                        </C.MainCard>
                      </C.MainCol>
                    ))}
                </C.MainRow>
              </C.CollapsePanel>
            </C.NftCollapse>

            <C.NftCollapse defaultActiveKey={["3"]}>
              <C.CollapsePanel
                header={
                  <N.CollapseHeader>
                    <N.CollapseHeaderTitle>Details</N.CollapseHeaderTitle>
                  </N.CollapseHeader>
                }
                key="2"
              >
                <C.MainRow>
                  {contractDetails &&
                    contractDetails?.map((item) => (
                      <>
                        <C.MainCol lg={6}>
                          <N.DeatilsTitle>{item?.key}</N.DeatilsTitle>
                        </C.MainCol>
                        <C.MainCol lg={6}>
                          <N.DeatilsValue>
                            {item?.key === "Contract Address" ? (
                              <a
                                href={`${ContractUtility.getNetworkExplorer(
                                  nftNetwork.toString()
                                )}/token/${item?.value}`}
                                target="_blank"
                              >
                                {CommonUtility.addressConvertor(item.value)}
                              </a>
                            ) : (
                              item?.value
                            )}
                          </N.DeatilsValue>
                        </C.MainCol>
                      </>
                    ))}
                </C.MainRow>
              </C.CollapsePanel>
            </C.NftCollapse>
          </C.MainCard>
        </C.MainCol>
      </C.MainRow>
    </div>
  );
};

export default NftDetailsSidebar;
